// Radnja koja čeka bazu kreće samo jednom (kao `onSubmit` u staroj aplikaciji): Enter dvaput, dvoklik ili dodir
// prije nego se gumb zaključa (`aria-busy`) ne šalju dvaput. TanStack Query javlja `isPending` tek u sljedećem
// zadatku (setTimeout 0), pa provjera `if (mut.isPending)` ne uhvati drugi Enter odmah iza prvog; brava je ref i
// zaključa se odmah.
import { useCallback, useRef } from 'react';

/**
 * `once(() => mut.mutateAsync(v))`: pokrene radnju samo ako prethodna ne čeka. Greške i dalje idu u `onError`
 * mutacije. S `stay` brava ostaje i nakon uspjeha (objava, nova ekipa: ekran odlazi, a drugi Enter u tom
 * trenutku ne smije napraviti još jednu).
 */
export function useOnce() {
  const busy = useRef(false);
  return useCallback((run: () => Promise<unknown>, stay = false) => {
    if (busy.current) return;
    busy.current = true;
    run().then(
      () => {
        if (!stay) busy.current = false;
      },
      () => {
        busy.current = false;
      },
    );
  }, []);
}
